import type { EventMarketType, EventType } from "app/types/eventType";
import React from "react";
import "./TwoWayMarketTypeSubheading.scss";

type TwoWayMarketTypeSubheadingProps = {
  event: EventType;
  market: EventMarketType;
};

const TwoWayMarketTypeSubheading: React.FC<TwoWayMarketTypeSubheadingProps> = ({
  event,
  market,
}) => {
  return (
    <div className={`${market.type.toLowerCase()} subheading twoway`}>
      <span key={"runner 1"}>{event.participant1}</span>
      <span key={"runner 2"}>{event.participant2}</span>
    </div>
  );
};

export default TwoWayMarketTypeSubheading;
